import { getLastAdjustSetting, getLastFiltersSetting, getLastPhysicsSetting } from './util'
import { applyAdjustAndFilters } from './adjust'
import createImageData from './createImageData'

export const downloadImage = ({ imageData, settingsList, currentSettingId }) => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  const lastAdjustSetting = getLastAdjustSetting(settingsList, currentSettingId)
  const lastFiltersSetting = getLastFiltersSetting(settingsList, currentSettingId)
  const lastPhysicsSetting = getLastPhysicsSetting(settingsList, currentSettingId)
  const currentImageData = lastPhysicsSetting ? lastPhysicsSetting.imageData : imageData

  canvas.width = currentImageData.width
  canvas.height = currentImageData.height

  // clone imageData since applyAdjustAndFilters changes it by reference
  const newImageData = createImageData(currentImageData.data, currentImageData.width, currentImageData.height)
  applyAdjustAndFilters(newImageData, lastAdjustSetting, lastFiltersSetting)

  context.putImageData(newImageData, 0, 0)

  const base64 = canvas.toDataURL()

  return { base64, newImageData }
}
